import type { Theme } from '@mui/material';
import type { StyleExtend } from 'providers/theme/theme.types';

export const ToggleButtonsGroupTitleStyle: StyleExtend<Theme> = {
  color: (theme) => theme.customStyling.toggleButtonsGroup.color,
  marginBottom: '.75rem',
};

export const ToggleButtonsGroupGridStyle: StyleExtend<Theme> = {
  display: 'grid',
  gap: '1rem',
  gridTemplateColumns: '1fr 1fr',
};
